import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FlowDataRule } from '@flashvpn-io/web-core';

@Component({
  selector: 'app-tarif-block',
  templateUrl: './tarif-block.component.html',
  styleUrl: '../../pages/subscription/subscription.component.css'
})
export class TarifBlockComponent {
  @Input() plan: FlowDataRule | null = null;
  @Input() tarif: string = '';
  @Input() image: string = '';
  @Input() price: string = '';
  @Input() discount: string = '';
  @Input() currentActive: FlowDataRule | null = null;
  @Output() setActive = new EventEmitter<FlowDataRule>();

  onTarifClick(): void {
    this.setActive.emit(this.plan as FlowDataRule);
  }
} 